import { render, staticRenderFns } from "./ConversationListComponent.vue?vue&type=template&id=3225a1f6&scoped=true&"
import script from "./ConversationListComponent.vue?vue&type=script&lang=js&"
export * from "./ConversationListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConversationListComponent.vue?vue&type=style&index=0&id=3225a1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225a1f6",
  null
  
)

export default component.exports